import React, { forwardRef, useImperativeHandle, useRef } from "react";

// Every source segment contains 121 frames at 24 fps.
const SEGMENT_SECONDS = 121 / 24;

const MobileRideVideo = forwardRef(function MobileRideVideo({ src, onReady, onPlaying, onNotice, onComplete }, ref) {
  const video = useRef(null);
  const stop = useRef(0);
  const waiting = useRef(false);
  const finished = useRef(false);

  useImperativeHandle(ref, () => ({
    startFromGesture() {
      stop.current = 0;
      waiting.current = false;
      finished.current = false;
      video.current.currentTime = 0;
      video.current.playbackRate = 1;
      return video.current.play();
    },
    pauseNow() { video.current.pause(); },
    resumeNow() {
      if (waiting.current) {
        stop.current += 1;
        waiting.current = false;
      }
      return video.current.play();
    },
    togglePause(value) {
      if (value) video.current.pause();
      else if (!waiting.current) return video.current.play();
    },
    reset() {
      video.current.pause();
      video.current.currentTime = 0;
      stop.current = 0;
      waiting.current = false;
      finished.current = false;
    },
  }), []);

  function checkPosition() {
    const player = video.current;
    if (waiting.current || finished.current) return;
    const noticeTime = (stop.current * 2 + 1) * SEGMENT_SECONDS + 4.65;
    if (stop.current < 5 && player.currentTime >= noticeTime) {
      waiting.current = true;
      player.pause();
      onNotice(stop.current);
    }
  }

  return <div className="ride-video-world">
    <video ref={video} className="ride-video-layer is-front" src={src}
      muted playsInline preload="auto" onLoadedData={onReady} onPlaying={onPlaying}
      onTimeUpdate={checkPosition} onEnded={() => {
        if (!finished.current) { finished.current = true; onComplete(); }
      }} aria-label="Whitefield ride" />
  </div>;
});

export default MobileRideVideo;
